// @flow
import React from 'react';
import FilterDefaultLogo from './FilterDefaultLogo';

type Props = {
    selection: any,
    onSelect: () => void,
    index: number
};

export default function FilterDropdownSelection({
    selection,
    onSelect,
    index
}: Props) {
    return (
        <div
            tabIndex={index + 1}
            role="button"
            aria-pressed="false"
            className="filter-selection"
            onClick={onSelect}
            data-testid="dropdown-item"
            onKeyPress={(event: any) => {
                const keyPressed = event.charCode;
                if (keyPressed === 13) {
                    onSelect();
                }
            }}
        >
            {selection.logo ? (
                <div
                    className={`logo ${
                        selection.isSelf ? 'profile-image' : 'team-logo'
                    }`}
                >
                    <img alt={selection.title} src={selection.logo} />
                </div>
            ) : (
                <FilterDefaultLogo />
            )}
            <div className="filter-title">{selection.title}</div>
        </div>
    );
}
